import React, { useContext } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import SmsIcon from '@material-ui/icons/Sms';
import messages, {MessageData} from '../../services/db/messages/messages';
import {makeStyles, Tooltip} from '@material-ui/core';
import MessageItem from './MessageItem';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Scrollbar from '../Scrollbar';
import IntlMessages from '../../utility/IntlMessages';
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
import {Fonts} from '../../../shared/constants/AppEnums';
import AppContextPropsType, {CremaTheme} from '../../../types/AppContextPropsType';
import { getUserToken } from '@crema/utility/AppHooks';
import { useGetTasksListQuery } from 'generated/graphql';
import { useHistory } from 'react-router-dom';
import AppContext from '@crema/utility/AppContext';
import { setAuthToken } from '@crema/services/ApiConfig';

const useStyles = makeStyles((theme: CremaTheme) => ({
  crPopover: {
    '& .MuiPopover-paper': {
      width: 260,
      [theme.breakpoints.up('sm')]: {
        width: 300,
      },
      [theme.breakpoints.up('xl')]: {
        width: 380,
      },
    },
    '& .scroll-submenu': {
      maxHeight: 200,
      [theme.breakpoints.up('xl')]: {
        maxHeight: 380,
      },
    },
  },
  btnPopover: {
    borderRadius: 0,
    width: '100%',
    textTransform: 'capitalize',
  },
  notiBtn: {
    justifyContent: 'flex-start',
    width: '100%',
    height: 56,
    fontSize: 16,
    borderRadius: 0,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    color: theme.palette.grey[800],
    '&:hover, &:focus': {
      color: theme.palette.text.primary,
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.up('sm')]: {
      height: 70,
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      width: 'auto',
      borderLeft: 'solid 1px',
      borderColor: theme.palette.grey[200],
      color: theme.palette.grey[400],
      '&:hover, &:focus': {
        color: theme.palette.text.primary,
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: '2.5rem',
      paddingRight: '2.5rem',
    },
  },
  listStyle: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  badgeStyle: {
    marginRight: 8,
  },
  smsIcon: {
    fontSize: 22,
    color: theme.palette.text.secondary,
    [theme.breakpoints.up('xl')]: {
      fontSize: 30,
    },
  },
  listRoot: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

interface HeaderMessagesProps {}

const HeaderMessages: React.FC<HeaderMessagesProps> = () => {
  const history = useHistory();
const {updateAuthUser} = useContext<AppContextPropsType>(AppContext);
  const [
    anchorMessages,
    setAnchorMessages,
  ] = React.useState<HTMLButtonElement | null>(null);

  const onClickMessagesButton = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorMessages(event.currentTarget);
  };

  const classes = useStyles();
  const token = getUserToken();
  const { data, loading, error } = useGetTasksListQuery({});
  const [taskData1, settaskData1] = React.useState([]);
  const [dataLoaded, setdataLoaded] = React.useState(false);

  if (!dataLoaded) {
    if (data === undefined) return null;
    else {
        let res: string = JSON.stringify(data);
        // console.log("task before:- ",res);
        settaskData1(JSON.parse(JSON.stringify(data?.AdminTaskList)));
    }
    if(error){
      let reqErr=JSON.stringify(error)
      if(reqErr){
    let reqErrObj = JSON.parse(reqErr)
    if(reqErrObj){
      // console.log("abcd",reqErrObj['message']);
      if(reqErrObj['message']=="Your are not Authorized"){
        updateAuthUser(null);
        setAuthToken(null);
       history.push("/signin");
      }
    }
    
  }
    }
    setdataLoaded(true);
  }
  const handleRedirectTask = () => {
    window.location.href = "/tasks-communication"

  }
  return (
    <>
    <Tooltip title={<IntlMessages id='header.tooltip.headerMessages' />}>
      <IconButton
        className={clsx(classes.notiBtn, 'notiBtn')}
        aria-label='show 4 new mails'
        color='inherit'
        onClick={onClickMessagesButton}>
        <Badge
          className={classes.badgeStyle}
          badgeContent={taskData1.length}
          color='secondary'>
          <SmsIcon className={clsx(classes.smsIcon, 'smsIcon')} />
        </Badge>
        <Hidden mdUp>
          <Box
            ml={4}
            fontSize={16}
            fontFamily='Poppins'
            fontWeight={Fonts.REGULAR}
            component='span'>
            <IntlMessages id='dashboard.messages' />
          </Box>
        </Hidden>
      </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorMessages}
        id='app-message'
        className={classes.crPopover}
        open={Boolean(anchorMessages)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setAnchorMessages(null)}>
        <Box>
          <Box px={5} py={3}>
          <Box component='h5' fontFamily='Roboto-Regular' fontSize={16}>
              <IntlMessages id='dashboard.messages' />{" "}<span className='numericTxt'>({taskData1.length})</span>
            </Box>
          </Box>
          <Scrollbar className='scroll-submenu'>
            <List
              className={classes.listRoot}
              onClick={() => {
                setAnchorMessages(null);
              }}>
            {taskData1.map((item: any, index) => (
           
           <Box pl={{ xs: 4 }} pr = {{xs: 4}} pb={{xs: 2}} component='p' color='text.secondary' key={index}>
            {item?.taskCount} &nbsp;&nbsp;  {item?.taskMessage}
           </Box>              
         ))}
            </List>
          </Scrollbar>
          <Box mt={2}>
            <Button
              className={classes.btnPopover}
              variant='contained'
              color='primary'
              onClick={handleRedirectTask}>
              <IntlMessages id='common.viewAll' />
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default HeaderMessages;
